import e, { useRef as u, useEffect as h } from "react";
import { ChevronDown as _ } from "@olxbr/ds-icons";
import { sendClickEvent as k } from "../../utils/sendClickEvent.js";
import { Link as x } from "../../../Link/Link.js";
import { Avatar as E } from "../../../Avatar/Avatar.js";
import { Skeleton as N } from "../../../Skeleton/Skeleton.js";
function n(_ref) {
  let {
    openSubMenu: o,
    onLogin: r,
    setOpenSubMenu: t,
    accountInfo: i,
    children: l
  } = _ref;
  const {
      isLogged: a,
      meIsLoading: m,
      profilePicture: s,
      userName: p
    } = i,
    c = u(null),
    d = {
      login: a
    };
  return h(() => {
    a && r();
  }, [a, r]), m ? e.createElement(N, {
    dsParentName: "Header",
    className: "olx-header__profile-skeleton",
    width: "135px",
    height: "40px"
  }) : e.createElement("span", {
    className: "olx-header__profile-item"
  }, a ? e.createElement("button", {
    "data-ds-component": "DS-Profile-Button",
    "aria-haspopup": "true",
    "aria-expanded": o,
    className: "olx-header__profile-link",
    "data-header-keyboard-navigation": "true",
    onClick: () => t(f => !f),
    ref: c
  }, e.createElement(E, {
    dsParentName: "Header",
    size: "32px",
    src: s
  }), e.createElement("span", {
    className: "olx-header__profile-nickname"
  }, p.split(" ")[0]), e.createElement(_, {
    size: "16"
  })) : e.createElement(x, {
    dsParentName: "Header",
    href: "https://conta.olx.com.br/anuncios",
    className: "olx-header__profile-link",
    "data-header-keyboard-navigation": "true",
    onClick: () => k("login", "main_menu", d)
  }, "Entrar"), l);
}
n.displayName = "Profile";
export { n as Profile };